import { useSessionHeartbeat } from 'utils/hooks/use-session-heartbeat'
import { getCookie } from 'utils/cookies'
import { useState, useEffect } from 'react'

export function SessionProvider() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = getCookie('access_token')
    return token !== null && token !== ''
  })

  useEffect(() => {
    if (isAuthenticated) {
      return
    }

    const checkAuthStatus = () => {
      const token = getCookie('access_token')
      const authenticated = token !== null && token !== ''
      setIsAuthenticated(authenticated)
    }

    const interval = setInterval(checkAuthStatus, 1000)

    return () => clearInterval(interval)
  }, [isAuthenticated])

  useSessionHeartbeat(isAuthenticated)

  return null
}
